"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var BurnerProvider_1 = require("../BurnerProvider");

var POLL_INTERVAL = 1000;

var AccountKeys =
/** @class */
function (_super) {
  __extends(AccountKeys, _super);

  function AccountKeys(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      keys: null
    };
    return _this;
  }

  AccountKeys.prototype.componentDidMount = function () {
    this.updateKeys();
  };

  AccountKeys.prototype.componentDidUpdate = function (oldProps) {
    if (this.props !== oldProps) {
      this.updateKeys();
    }
  };

  AccountKeys.prototype.updateKeys = function () {
    var _a = this.props,
        account = _a.account,
        accounts = _a.accounts,
        actions = _a.actions;

    if (accounts.indexOf(account) === -1 || !actions.canCallSigner('readKey', account)) {
      this.setState({
        keys: null
      });
      return;
    }

    var keys = {
      privateKey: actions.callSigner('readKey', account),
      burnAccount: function burnAccount() {
        return actions.callSigner('burn', account);
      }
    };
    this.setState({
      keys: keys
    });
  };

  AccountKeys.prototype.render = function () {
    return this.props.render(this.state.keys);
  };

  return AccountKeys;
}(react_1.Component);

exports.default = BurnerProvider_1.withBurner(AccountKeys);